export default __webpack_public_path__ + "static/media/diagonal.1ed8c2da.png";